import { Card } from 'antd';
import { Flex } from '@/components';

export interface MemberRow {
  username: string;
  firstName: string;
  lastName: string;
  type?: string;
  date: string | React.ReactElement;
  statusRaw: DormitoryMemberStatus;
  status: React.ReactElement;
}

export interface MobileMembersListProps {
  rows: MemberRow[];
}

export default function MobileMembersList({ rows }: MobileMembersListProps) {
  return (
    <Flex className="mb-4" direction="column">
      {rows.map((row, i) => (
        <Card key={i} size="small">
          <Flex align="center">
            <span className="text-sm">{row.firstName} {row.lastName} - {row.username}</span>
            <span className="text-sm ms-auto">{row.status}</span>
          </Flex>
        </Card>
      ))}
    </Flex>
  );
}
